import { apiClient } from "@/api";
import { ApiResponse, PaginatedData } from "@/types";
import type { AxiosRequestConfig } from "axios";

export type IAdminRole = "administrator" | "editor" | "viewer";

export type IAdminStatus = "active" | "inactive";

export interface GetListAdminReq {
  search?: string;
  role?: IAdminRole;
  page: number;
  page_size: number;
}

export interface GetListAdminRes {
  id: string;
  name: string;
  email: string;
  role: string;
  status: string;
  last_login_at: string;
}

export interface CreateAdminReq {
  name: string;
  email: string;
  role: IAdminRole;
  status: IAdminStatus;
}

export interface IAdminDetailRes {
  id: string;
  name: string;
  email: string;
  role: string;
  status: string;
  last_login_at: string;
  created_at: string;
  created_by_name: string;
  permissions: IAdminPermission;
}

export type AdminPermissionAction = "read" | "create" | "update" | "delete";

export interface IAdminPermission {
  dashboard: AdminPermissionAction[];
  user_management: AdminPermissionAction[];
  agent_management: AdminPermissionAction[];
  project_management: AdminPermissionAction[];
  inquiry_management: AdminPermissionAction[];
  ax_trend_hub: AdminPermissionAction[];
  admin_management: AdminPermissionAction[];
}

export type IAdmin = Omit<GetListAdminRes, "last_login_at">;

export const AdminManagementService = {
  getList: (params: GetListAdminReq, config?: AxiosRequestConfig) => {
    return apiClient.get<ApiResponse<PaginatedData<GetListAdminRes>>>("admins/", { ...config, params });
  },

  getDetailAdmin: (id: string, config?: AxiosRequestConfig) => {
    return apiClient.get<ApiResponse<IAdminDetailRes>>(`admins/${id}`, config);
  },

  createAdmin: (req: CreateAdminReq, config?: AxiosRequestConfig) => {
    return apiClient.post<ApiResponse<IAdmin>>("admins/", req, config);
  },

  editAdmin: (id: string, req: CreateAdminReq, config?: AxiosRequestConfig) => {
    return apiClient.put<ApiResponse<IAdmin>>(`admins/${id}`, req, config);
  },
  deleteAdmin: (id: string, config?: AxiosRequestConfig) => {
    return apiClient.delete(`admins/${id}`, config);
  },
};
